import React from 'react';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { Routing } from '../../../../util/routes.util';
import Crumb, { CrumbTemplateProps } from '../Crumb';

export default function AssetOverviewCrumb({ current }: CrumbTemplateProps) {
  return <Crumb current={current} text={t(TranslationKey.asset).plural.upper} path={Routing.assets.info()} />;
}
